import Vue from 'vue'
import Router from 'vue-router'

// Containers
const TheContainer = () => import('@/containers/TheContainer')
// Views
const Home = () => import('@/views/Home')
// Views - Components
const UsersMain = () => import('@/views/administration/UsersMain')
const ProductSpecificationMain = () => import('@/views/administration/ProductSpecificationMain')
const GeneralMain = () => import('@/views/administration/GeneralMain')
const UnitsMain = () => import('@/views/administration/UnitsMain')
const ContractManagementMain = () => import('@/views/administration/ContractManagementMain')
const GroupPermission = () => import('@/views/administration/users/GroupPermission')
const Portfolio = () => import('@/views/Portfolio')
const Alerts = () => import('@/views/Alerts')
const Clients = () => import('@/views/Clients')
const Companies = () => import('@/views/Companies')
const Contracts = () => import('@/views/Contracts')
const TradingGroups = () => import('@/views/TradingGroups')
const TradingForm = () => import('@/views/templates/TradingGroup')
const Trades = () => import('@/views/Trades')
const Uploads = () => import('@/views/Uploads')
const Triggers = () => import('@/views/Triggers')
const Reports = () => import('@/views/Reports/Reports')
const AvailableReports = () => import('@/views/Reports/AvailableReports')
const AdminReports = () => import('@/views/Reports/AdminReports')
const ReportTemplateBuilder = () => import('@/views/Reports/ReportTemplateBuilder')
const Markets = () => import('@/views/Markets')
const Management = () => import('@/views/Management')
const SsoLanding = () => import('@/views/SsoLanding')
const Profile = () => import('@/views/users/Profile')
const ContractType = () => import('@/views/administration/ContractType')
const ClientsForm = () => import('@/views/templates/ClientsForm')
const ClientReportTabs = () => import('@/views/clients/ClientReportTabs')
const ATGReportTabs = () => import('@/views/templates/ATGReports/ATGReportTabs')
const CompanyForm = () => import('@/views/templates/CompanyForm')
const TradeForm = () => import('@/views/templates/TradeForm')
const ContractForm = () => import('@/views/contracts/ContractMain')
const ContractReportTabs = () => import('@/views/contracts/ContractReportTabs')
const ExpiredTrigger = () => import('@/views/triggers/ExpiredTrigger')
const DueLiveTrigger = () => import('@/views/triggers/DueLiveTrigger')
const ActiveTrigger = () => import('@/views/triggers/ActiveTrigger')
const StatusAlert = () => import('@/views/triggerAlerts/StatusAlert')
const TriggerHitAlert = () => import('@/views/triggerAlerts/TriggerHitAlert')
const DeadlineAlert = () => import('@/views/triggerAlerts/DeadlineAlert')
const MyClients = () => import('@/views/portfolio/Clients')
const PDFViewer = () => import('@/views/helperTemplates/PdfComponent')
const SecureVersion = () => import('@/views/SecureVersion')

Vue.use(Router)

export default new Router({
    mode: 'history', // no hash in url - works better with outside redirections
    linkActiveClass: 'active',
    scrollBehavior: () => ({ y: 0 }),
    routes: configRoutes()
})

function configRoutes() {
    return [
        {
            path: '/ssolanding',
            component: SsoLanding
        },
        {
            path: '/',
            redirect: '/ssolanding',
            name: '',
            component: TheContainer,
            children: [
                {
                    path: 'home',
                    name: 'Home',
                    component: Home
                },
                {
                    path: 'secureVersion',
                    name: 'SecureVersion',
                    component: SecureVersion
                },
                {
                    path: 'portfolio',
                    name: 'Portfolio',
                    component: Portfolio
                },
                {
                    path: 'portfolio',
                    redirect: '/portfolio',
                    name: 'Portfolio',
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: 'portfolio',
                            name: 'MyPortfolio',
                            component: Portfolio
                        },
                        {
                            path: 'clients',
                            name: 'MyClients',
                            component: MyClients
                        },
                        {
                            path: 'trades',
                            name: 'MyTrades',
                            component: Trades
                        },
                        {
                            path: 'triggers',
                            name: 'MyTriggers',
                            component: Triggers
                        },
                        {
                            path: 'alerts',
                            name: 'MyAlerts',
                            component: Alerts
                        }
                    ],
                },
                //{
                //    path: 'alerts',
                //    name: 'Alerts',
                //    component: Alerts
                //},
                {
                    path: 'alerts',
                    redirect: '/alerts/triggerHitAlert',
                    name: 'Alerts',
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                        path: 'statusAlert',
                        name: 'Trigger Status',
                        component: StatusAlert
                    },
                    {
                        path: 'triggerHitAlert',
                        name: 'Hit Triggers',
                        component: TriggerHitAlert
                    },
                    {
                        path: 'deadlineAlert',
                        name: 'Default Deadlines',
                        component: DeadlineAlert
                    }],
                },
                {
                    path: 'clients',
                    name: 'Clients',
                    component: Clients,
                },
                {
                    path: 'clients',
                    name: 'Clients',
                    component: Clients,
                },
                {
                    path: 'pdfViewer/:fileName?',
                    name: 'PDFViewer',
                    component: PDFViewer,
                },
                {
                    path: 'clients',
                    name: 'Clients',
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                        path: 'clientedit/:clientId?',
                        name: 'Client',
                        component: ClientsForm
                    },
                    {
                        path: 'reports/:clientId?',
                        name: 'ClientReports',
                        component: ClientReportTabs
                    }]
                },
                {
                    path: 'companies',
                    name: 'Companies',
                    component: Companies
                },
                {
                    path: 'companies',
                    name: 'Companies',
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                        path: 'companyedit/:clientId?',
                        name: 'Company',
                        component: CompanyForm
                    }]
                },
                {
                    path: 'contracts/:utilityType?',
                    name: 'Contracts',
                    component: Contracts
                },
                {
                    path: 'contracts',
                    name: 'Contracts',
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                        path: 'contractedit/:contractId?',
                        name: 'Contract',
                        component: ContractForm
                    },
                    {
                        path: 'reportsUI/:contractId?',
                        name: 'Reports UI',
                        component: ContractReportTabs
                    }]
                },
                {
                    path: 'tradingGroups',
                    name: 'TradingGroups',
                    component: TradingGroups
                },
                {
                    path: 'tradingGroups',
                    name: 'TradingGroups',
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                        path: 'tradinggroupedit/:tradingGroupId?',
                        name: 'TradingGroup',
                        component: TradingForm
                    },
                    {
                        path: 'reports/:tradingGroupId?',
                        name: 'ATGReports',
                        component: ATGReportTabs
                    }]
                },
                {
                    path: 'trades',
                    name: 'Trades',
                    component: Trades
                },
                {
                    path: 'trades',
                    name: 'Trades',
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                        path: 'tradeedit/:tradeId?',
                        name: 'Trade',
                        component: TradeForm
                    }]
                },
                {
                    path: 'uploads',
                    name: 'Uploads',
                    component: Uploads
                },
                {
                    path: 'reports',
                    name: 'Reports',
                    component: Reports
                },
                {
                    path: 'reports',
                    name: 'Reports',
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                        path: 'reports',
                        name: 'Report Templates',
                        component: Reports
                    },
                    {
                        path: 'reportTemplateBuilder',
                        name: 'Report Template Builder',
                        component: ReportTemplateBuilder
                    },
                    {
                        path: 'availableReports',
                        name: 'Available Reports',
                        component: AvailableReports
                    },
                    {
                        path: 'adminReports',
                        name: 'Admin Reports',
                        component: AdminReports
                    }
                    ]
                },
                {
                    path: 'triggers',
                    name: 'Triggers',
                    component: Triggers
                },
                {
                    path: 'triggers',
                    redirect: '/home',
                    name: 'Triggers',
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                        path: 'expired',
                        name: 'Expired',
                        component: ExpiredTrigger
                    },
                    {
                        path: 'dueLive',
                        name: 'Due Live',
                        component: DueLiveTrigger
                    },
                    {
                        path: 'Live',
                        name: 'Live',
                        component: ActiveTrigger
                    }]
                },
                {
                    path: 'markets',
                    name: 'Markets',
                    component: Markets
                },
                {
                    path: 'management',
                    name: 'Management',
                    component: Management
                },
                {
                    path: 'users',
                    redirect: '/home',
                    name: 'Users',
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: 'profile',
                            name: 'Profile',
                            component: Profile
                        }
                    ]

                },
                {
                    path: 'administration',
                    redirect: '/home',
                    name: 'Administration',
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: 'users',
                            name: 'Users & Permissions',
                            component: UsersMain
                        },
                        {
                            path: 'products',
                            name: 'Product Specifications',
                            component: ProductSpecificationMain
                        },
                        {
                            path: 'general',
                            name: 'General',
                            component: GeneralMain
                        },
                        {
                            path: 'contractManagement',
                            name: 'Contract Management',
                            component: ContractManagementMain
                        },
                        {
                            path: 'units',
                            name: 'Units',
                            component: UnitsMain
                        },
                        {
                            path: 'users',
                            name: 'Users & Permissions',
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [{
                                path: 'groupPermission/:groupId',
                                name: 'Group Permission',
                                component: GroupPermission
                            }]
                        },
                        {
                            path: 'contractType',
                            name: 'contractType',
                            component: ContractType
                        },


                    ]
                },

            ]
        }
    ]
}

